/** Nombre visible de cada rol de la Iglesia. */
export const ROLE_LABELS: Record<string, string> = {
  admin: 'Administrador',
  pastor: 'Pastor',
  department_leader: 'Líder',
  member: 'Miembro',
  guest: 'Invitado',
};

export const roleLabel = (key: string) => ROLE_LABELS[key] ?? key;

export const fullName = (m: { givenName: string; familyName: string }) => `${m.givenName} ${m.familyName}`.trim() || 'Persona';

export const formatDay = (iso: string | null) => (iso ? new Date(iso).toLocaleDateString('es', { day: 'numeric', month: 'long', year: 'numeric' }) : '—');
